var getSkillUniqueId = function (skill) {
    return skill.id + "_" + skill.category;
};
export { getSkillUniqueId };
